<template>
  <v-layout :row-classes="['row', 'contains-special-sale']">
    <nav class="content-menu hidden-for-small-only">
      <span class="nav-header hide-for-small-only"/>
    </nav>

    <div class="col" role="main">
      <h1>Verlenging van je Arriva abonnement uit 2016</h1>
      <div class="subheader">Verlenging van je oude abonnement</div>
      <article class="collapsible">
        <div class="collapser">
          <p>
            Reis je sinds 2016 met een regionaal Arriva abonnement (Arriva Altijd Vrij, Arriva Dal Vrij,
            Arriva DalKorting ZH, Arriva Altijd Korting Scholier of Kids Vrij Meereizen) in de regio Duin-
            en Bollenstreek, Leiden, Rijnstreek en Midden-Holland? Dan kun je je jaar- of maandabonnement,
            die je ook in 2016 had, verlengen door je OV-chipkaart hieronder in te vullen. De prijzen voor 2023 zijn:
          </p>

          <table id="subscription-extension" class="responsive-table">
            <tbody>
              <tr>
                <th>Arriva Maandproducten Verlengregeling</th>
                <th>2023</th>
              </tr>
              <tr>
                <td>Arriva Dalvrij ZHN Bus (vol tarief)</td>
                <td>€ 91,00</td>
              </tr>
              <tr>
                <td>Arriva Dalvrij ZHN Bus + Qliner (vol tarief)</td>
                <td>€ 108,00</td>
              </tr>
              <tr>
                <td>Altijd Korting Scholier (12-18 jaar)</td>
                <td>€ 31,00</td>
              </tr>
              <tr>
                <td>Arriva Altijd Vrij ZHN Bus (12-18 jaar)</td>
                <td>€ 145,00</td>
              </tr>
              <tr>
                <td>Arriva Altijd Vrij ZHN Bus (vol tarief)</td>
                <td>€ 264,00</td>
              </tr>
              <tr>
                <td>Arriva Altijd Vrij ZHN Bus + Qliner + R-net (12-18 jaar)</td>
                <td>€ 179,00</td>
              </tr>
              <tr>
                <td>Arriva Altijd Vrij ZHN Bus + Qliner + R-net (vol tarief)</td>
                <td>€ 323,00</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <th>Arriva Jaarproducten Verlengregeling</th>
                <th>2023</th>
              </tr>
              <tr>
                <td>Arriva Dal Korting ZH Bus</td>
                <td>€ 27,00</td>
              </tr>
              <tr>
                <td>Arriva Dalvrij ZHN Bus (vol tarief)</td>
                <td>€ 908,00</td>
              </tr>
              <tr>
                <td>Arriva Dalvrij ZHN Bus + Qliner + R-net (vol tarief)</td>
                <td>€ 1.077,00</td>
              </tr>
              <tr>
                <td>Altijd Korting Scholier (12-18 jaar)</td>
                <td>€ 314,00</td>
              </tr>
              <tr>
                <td>Arriva Altijd Vrij ZHN Bus (12-18 jaar)</td>
                <td>€ 1.454,00</td>
              </tr>
              <tr>
                <td>Arriva Altijd Vrij ZHN Bus (vol tarief)</td>
                <td>€ 2.636,00</td>
              </tr>
              <tr>
                <td>Arriva Altijd Vrij ZHN Bus + Qliner + R-net (12-18 jaar)</td>
                <td>€ 1.795,00</td>
              </tr>
              <tr>
                <td>Arriva Altijd Vrij ZHN Bus + Qliner + R-net (vol tarief)</td>
                <td>€ 3.230,00</td>
              </tr>
              <tr>
                <td>Arriva Kids Vrij Meereizen jaar (4-11 jaar)</td>
                <td>€ 20,00</td>
              </tr>
            </tbody>
          </table>
        </div>
      </article>

      <div class="ov-chip-card-form clearfix">
        <form id="ovchipcard" method="get" class="order-product" @submit.prevent="checkEligibility">
          <fieldset>
            <engraved-id v-model="engravedId"
                         :validation="$v.engravedId"
                         :validate-on-blur="false"
                         :show-part-validation-errors="false"
                         :label="'specialSale.engravedIdLabel'"
            />
            <button type="submit" class="card-number-submit">{{ $t('specialSale.checkEligibilityButton') }}</button>
          </fieldset>
        </form>
      </div>

      <div class="ov-chip-card-form clearfix">
        <form id="productgroup" method="get" class="order-product" @submit.prevent="orderConfiguration">
          <fieldset v-if="eligibilityChecked">
            <template v-if="eligibleConfigurations.length > 0">
              <label for="productConfiguration" class="required">
                {{ $t('specialSale.productConfigurationLabel') }}
              </label>
              <div v-for="configuration in eligibleConfigurations" :key="configuration.id">
                <input :value="configuration" :id="configuration.id"
                       v-model="selectedConfiguration" type="radio" name="productConfiguration">
                <label :for="configuration.id">{{ configuration.product.title }}</label>
              </div>
              <button :disabled="selectedConfiguration===null" type="submit" class="card-number-submit">
                {{ $t('specialSale.configurationForm.submit') }}
              </button>
            </template>
            <template v-if="validationMessages.length === 0 && eligibleConfigurations.length === 0">
              <p>
                Sorry!
              </p>
              <p>
                We kunnen op je persoonlijke OV-chipkaart geen ‘oud’ Arriva-abonnement vinden dat je wilt
                verlengen. Kun je je OV-chipkaartnummer nogmaals controleren?
              </p>
              <p>
                Als je het OV-chipkaartnummer goed hebt ingevoerd, en de begindatum van je Arriva-abonnement
                viel in 2016, neem dan alsjeblieft contact op met onze Klantenservice. Zij zorgen er dan
                voor dat jouw abonnement verlengd wordt.
              </p>
            </template>
          </fieldset>
        </form>
      </div>

    </div>
  </v-layout>
</template>

<script>
import VLayout from '../layouts/Default'
import EngravedId from '../forms/order-item/EngravedId'
import bodyClassMixin from '../mixins/body-class'
import { validationMixin, withParams } from 'vuelidate'
import minLength from 'vuelidate/lib/validators/minLength'
import { required } from 'vuelidate/lib/validators'
import { regex } from 'vuelidate/lib/validators/common'
import {
  CARD_NUMBER_INVALID,
  CARD_NOT_FOUND_AT_TLS,
  CARD_LOCALLY_BLACKLISTED,
  CARD_NOT_ACTIVE_AT_TLS,
  ORDER_HAS_PRODUCT_CONFLICT_CRITICAL,
  ORDER_HAS_PRODUCT_CONFLICT_HIGH,
  ORDER_HAS_PRODUCT_CONFLICT_MEDIUM
} from '../order-api/order-api-client-constants'

export default {
  name: 'SpecialSalePage',
  components: {
    VLayout,
    EngravedId
  },
  mixins: [validationMixin, bodyClassMixin],
  data: function () {
    return {
      engravedId: '',
      specialSaleConfigurations: [],
      eligibleConfigurations: [],
      eligibilityChecked: false,
      selectedConfiguration: null,
      specialSaleSlug: null,
      validationMessages: []
    }
  },
  computed: {
    engravedIdErrorCode: function () {
      if (this.hasErrorForCode(CARD_NUMBER_INVALID)) return CARD_NUMBER_INVALID
      if (this.hasErrorForCode(CARD_NOT_FOUND_AT_TLS)) return CARD_NOT_FOUND_AT_TLS
      if (this.hasErrorForCode(CARD_NOT_ACTIVE_AT_TLS)) return CARD_NOT_ACTIVE_AT_TLS
      if (this.hasErrorForCode(CARD_LOCALLY_BLACKLISTED)) return CARD_LOCALLY_BLACKLISTED
      if (this.hasErrorForCode(ORDER_HAS_PRODUCT_CONFLICT_CRITICAL)) return ORDER_HAS_PRODUCT_CONFLICT_CRITICAL
      if (this.hasErrorForCode(ORDER_HAS_PRODUCT_CONFLICT_HIGH)) return ORDER_HAS_PRODUCT_CONFLICT_HIGH
      if (this.hasErrorForCode(ORDER_HAS_PRODUCT_CONFLICT_MEDIUM)) return ORDER_HAS_PRODUCT_CONFLICT_MEDIUM

      return null
    }
  },
  watch: {
    engravedId: function () {
      this.eligibilityChecked = false
    }
  },
  mounted: async function () {
    this.specialSaleConfigurations = (await this.$container.productsApiClient.getBestSpecialSaleConfigurations()).data.configurations
    this.saleSlug = this.$route.params.slug
  },
  methods: {
    hasErrorForCode: function (code) {
      return this.validationMessages.some(error => error.code === code)
    },
    checkEligibility: async function () {
      this.validationMessages = []
      this.eligibleConfigurations = []
      this.selectedConfiguration = null
      this.eligibilityChecked = false
      this.$v.$touch()
      if (!this.$v.$error) {
        try {
          const response = await this.$container.orderApiClient.filterProductConfigurations(this.specialSaleConfigurations, this.saleSlug, this.engravedId)
          if (response.hasOwnProperty('productConfigurations')) {
            const eligibleConfigurationSummaries = response.productConfigurations
            const eligibleConfigurationCodes = eligibleConfigurationSummaries.map(summary => summary.code)
            this.eligibleConfigurations = this.specialSaleConfigurations.filter(
              configuration => eligibleConfigurationCodes.includes(configuration.orderCode))
          } else if (response.hasOwnProperty('errors')) {
            this.validationMessages = response.errors
          }
        } catch (error) {
          throw error
        } finally {
          this.eligibilityChecked = true
        }
      }
    },
    orderConfiguration: function () {
      this.$router.push({
        name: 'ProductOverview',
        params: { lang: this.$router.currentRoute.params.lang },
        query: {
          productGroupId: this.selectedConfiguration.product.deeplinkId,
          customerGroup: this.selectedConfiguration.customerGroup.deeplinkId,
          engravedId: this.engravedId,
          sale: this.saleSlug
        }
      }).catch(() => {})
    }
  },
  validations: {
    engravedId: {
      required,
      minLength: minLength(16),
      regex: regex('regex', /^(?!352806).*/),
      hasConfiguration () { return true },
      errorCode () { return withParams({ code: this.engravedIdErrorCode }, () => !this.engravedIdErrorCode)() }
    }
  }
}
</script>

<style scoped>
  #subscription-extension th {
    font-weight: bold;
  }

  #subscription-extension td, #subscription-extension th {
    padding-left: 8px;
    font-size: 0.9em;
  }
  #subscription-extension td:last-of-type, th:last-of-type {
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/pages/SpecialSale.vue